




import InviteMerchantSignupService from '@/api/InviteMerchantSignupService';
import flagKeys from '@/constants/flagKeys';
import eventBus from '@/utils/eventBus';
import { Vue, Component } from 'vue-property-decorator';

@Component({
  components: {}
})
export default class InviteMerchantSignupModalsModel extends Vue {
  service = new InviteMerchantSignupService();

  submitLoading = false;

  onClose() {
    eventBus.$emit('closeModal');
  }
}
